import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../App';
import { notifApi } from '../services/api';

function timeAgo(iso) {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 2)   return 'just now';
  if (mins < 60)  return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24)   return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export default function Navbar({ title, subtitle, onMenuToggle }) {
  const { user, logout }          = useAuth();
  const [notifs, setNotifs]       = useState([]);
  const [showDrop, setShowDrop]   = useState(false);
  const dropRef = useRef(null);

  const unread = notifs.filter((n) => !n.read).length;

  useEffect(() => {
    if (!user) return;
    loadNotifs();
    const t = setInterval(loadNotifs, 30000);
    return () => clearInterval(t);
  }, [user]); // eslint-disable-line

  async function loadNotifs() {
    try {
      const data = await notifApi.getAll(user.userId);
      setNotifs(data.notifications || []);
    } catch (_) {}
  }

  useEffect(() => {
    function onClickOut(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) setShowDrop(false);
    }
    document.addEventListener('mousedown', onClickOut);
    return () => document.removeEventListener('mousedown', onClickOut);
  }, []);

  async function markAllRead() {
    try {
      await notifApi.markRead({ notificationId: 'all', userId: user.userId });
      setNotifs((n) => n.map((x) => ({ ...x, read: true })));
    } catch (_) {}
  }

  async function markOne(id) {
    try {
      await notifApi.markRead({ notificationId: id, userId: user.userId });
      setNotifs((n) => n.map((x) => (x.id === id ? { ...x, read: true } : x)));
    } catch (_) {}
  }

  const initials = user?.name?.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase() || '?';

  return (
    <div className="topbar">
      {onMenuToggle && (
        <button className="hamburger-btn" onClick={onMenuToggle} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
      )}
      <div className="topbar-title">
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>

      <div className="topbar-right">
        {/* Notification Bell */}
        <div className="notif-wrap" ref={dropRef}>
          <button className="notif-btn" onClick={() => setShowDrop((s) => !s)} title="Notifications">
            🔔
            {unread > 0 && <span className="notif-badge">{unread > 9 ? '9+' : unread}</span>}
          </button>

          {showDrop && (
            <div className="notif-dropdown">
              <div className="notif-header">
                <span>Notifications</span>
                {unread > 0 && (
                  <button className="btn btn-ghost btn-sm" onClick={markAllRead}>Mark all read</button>
                )}
              </div>
              <div className="notif-list">
                {notifs.length === 0 ? (
                  <div className="notif-empty">No notifications yet</div>
                ) : (
                  notifs.map((n) => (
                    <div
                      key={n.id}
                      className={`notif-item${n.read ? '' : ' unread'}`}
                      onClick={() => !n.read && markOne(n.id)}
                    >
                      <div className="notif-msg">{n.message}</div>
                      <div className="notif-time">{timeAgo(n.createdAt)}</div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>

        {/* User chip */}
        <div className="flex-gap topbar-user">
          <div className="avatar avatar-sm" style={{ background: user?.userType === 'admin' ? '#7c3aed' : user?.userType === 'school' ? '#0369a1' : '#d97706' }}>
            {initials}
          </div>
          <span className="topbar-username" style={{ fontSize: 13, fontWeight: 600, color: 'var(--gray-700)' }}>{user?.name}</span>
        </div>

        <button className="btn btn-outline btn-sm" onClick={logout}>Sign Out</button>
      </div>
    </div>
  );
}
